import { ref } from 'vue'
import { defineStore } from 'pinia'
import type { EnquiryImageInput, EnquiryType } from '@/graphql/api'

export const useEnquiryFormStore = defineStore('enquiryForm', () => {
    const enquiryType = ref<EnquiryType | null>(null)
    const enquiryImage = ref<EnquiryImageInput | null>(null)
    const isFetching = ref(false)
    const sourceUrl = ref<string | null>(null)

    const openEnquiryForm = (
        type: EnquiryType,
        image?: EnquiryImageInput,
        url?: string
    ) => {
        sourceUrl.value = url || null
        enquiryImage.value = image || null
        enquiryType.value = type
    }

    const closeEnquiryForm = () => {
        enquiryType.value = null
        enquiryImage.value = null
        isFetching.value = false
        sourceUrl.value = null
    }

    return {
        enquiryType,
        enquiryImage,
        isFetching,
        sourceUrl,
        openEnquiryForm,
        closeEnquiryForm,
    }
})
